var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  null,
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-217a72d2\"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./myRecommend.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/views/member-center/right/myRecommend.vue
// module id = 1484
// module chunks = 1